import classes from '@nerdwallet/base-styles/classes';
import classNames from 'classnames';
import _ from 'lodash';
import React from 'react';

import NwNextSteps from '@nerdwallet/react-next-steps';
import { getPageTaxonomyDataElem } from '@nerdwallet/wp-api/selectors/common';

import { nextStepsPropTypes } from '../../../lib/propTypes';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types -- directive added automatically by Shepherd migration
const NextSteps = ({ article, heading, ...props }) => {
  const { items } = props;
  if (_.isEmpty(items)) {
    return null;
  }

  // Ensure we send only valid items.
  const cleanProps = { ...props };
  cleanProps.items = items.filter(
    (item) =>
      item.title && item.category !== 'select' && item.url && item.url !== '#'
  );
  if (_.isEmpty(cleanProps.items)) {
    return null;
  }

  const trkProps = {
    trkPageType: 'article',
    trkTaxonomy: {
      pageType: getPageTaxonomyDataElem(article, 'pageType')?.value,
      topic: getPageTaxonomyDataElem(article, 'topic')?.value,
      vertical: getPageTaxonomyDataElem(article, 'vertical')?.value,
    },
  };

  return (
    <div
      className={classNames([
        'next-steps',
        classes(['margin-bottom-4', 'display-none', 'display-block--wide']),
      ])}
    >
      <NwNextSteps heading={heading} {...trkProps} {...cleanProps} />
    </div>
  );
};

NextSteps.propTypes = nextStepsPropTypes;

NextSteps.defaultProps = {
  heading: "What's Next?",
};

export default NextSteps;
